// src/services/announcementService.js
import apiClient from './api';

export default {
  getAnnouncements(params = {}) {
    // params: { page: 1, limit: 10, verified: true, search: '...' }
    return apiClient.get('/announcements', { params });
  },
  getAnnouncement(id) {
    return apiClient.get(`/announcements/${id}`);
  },
  createAnnouncement(data) {
    // data: { title, description, price, location, contact_info }
    return apiClient.post('/announcements', data);
  },
  updateAnnouncement(id, data) {
    return apiClient.put(`/announcements/${id}`, data);
  },
  deleteAnnouncement(id) {
    return apiClient.delete(`/announcements/${id}`);
  },
  verifyAnnouncement(id, isVerified) {
    // isVerified: boolean (true/false)
    return apiClient.patch(`/announcements/${id}/verify`, { is_verified: isVerified });
  },
  uploadImages(id, formData) {
    // formData: FormData nesnesi içinde 'images' anahtarıyla dosyaları içermeli
    return apiClient.post(`/announcements/${id}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data' // Önemli: Dosya yükleme için header
      }
    });
  },
  deleteImage(announcementId, imageId) {
    return apiClient.delete(`/announcements/${announcementId}/images/${imageId}`);
  }
};